module.exports = __webpack_public_path__ + "static/media/search_icon_button.59fb4b0d.svg";